import classNames from 'classnames'
import { type FC } from 'react'
import { useButtonClassName } from '../../../../components/Button/useButtonClassName'
import { PII_SHIELD_LEARN_MORE_URL, PII_SHIELD_REQUEST_ACCESS_URL } from '../../constants'
import './PiiShieldTab.scss'

interface HowItWorksStep {
  icon: string
  title: string
  description: string
}

const HOW_IT_WORKS_STEPS: HowItWorksStep[] = [
  { icon: 'bi-shield-lock', title: 'Request access', description: "Let us know you're interested in PII Shield." },
  { icon: 'bi-shield-check', title: "We'll reach out", description: "We'll get in touch to talk through how it works for your firm." },
  { icon: 'bi-check-circle', title: 'Set up your configuration', description: "Once enabled, we'll help you configure your settings." },
]

export const PiiShieldRequestAccess: FC = () => {
  const primaryButtonClass = useButtonClassName('primary', 'pii-shield-action-btn button-medium')
  const learnMoreButtonClass = useButtonClassName('grayGhost', 'pii-shield-action-btn button-medium')

  return (
    <div className='d-flex flex-column zocks-gap-2'>
      <div className='d-flex flex-column zocks-gap-2 pt-4 px-4 zocks-pb-2 rounded-4 border zocks-border-color-gray-300 pii-shield-how-it-works'>
        <div className='d-flex flex-column zocks-gap-0.5'>
          <div className='paragraph-large fw-bold zocks-text-gray-900'>How it works</div>
          <div className='paragraph-medium zocks-text-gray-600'>Getting started takes three steps</div>
        </div>
        <div className='d-flex flex-column'>
          {HOW_IT_WORKS_STEPS.map((step, index) => {
            const isLast = index === HOW_IT_WORKS_STEPS.length - 1
            return (
              <div key={step.title} className='d-flex zocks-gap-1'>
                <div className='d-flex flex-column align-items-center flex-shrink-0'>
                  <div className='d-flex align-items-center justify-content-center rounded-3 border zocks-border-color-gray-200 zocks-bg-color-gray-100 pii-shield-step-icon'>
                    <i className={`bi ${step.icon} zocks-text-primary`} />
                  </div>
                  {isLast ? null : <div className='flex-grow-1 pii-shield-step-connector' />}
                </div>
                <div className={classNames('d-flex flex-column zocks-gap-0.125', { 'pb-3': !isLast })}>
                  <div className='paragraph-medium fw-bold zocks-text-gray-900'>{step.title}</div>
                  <div className='paragraph-medium zocks-text-gray-600'>{step.description}</div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
      <div className='d-flex zocks-gap-1 align-items-center'>
        <a href={PII_SHIELD_REQUEST_ACCESS_URL} target='_blank' rel='noopener noreferrer' className={primaryButtonClass}>
          Request access
        </a>
        <a href={PII_SHIELD_LEARN_MORE_URL} target='_blank' rel='noopener noreferrer' className={learnMoreButtonClass}>
          Learn more
          <i className='bi bi-box-arrow-up-right ms-1' />
        </a>
      </div>
    </div>
  )
}
